import { FC, HTMLAttributes } from 'react';

import { CapsuleShapedLink, TagList } from './TagBlock.styles';

type Inheritables = Omit<HTMLAttributes<HTMLUListElement>, 'children'>;
type Tag = { name: string; href: string };
type Props = { tags: Tag[] } & Inheritables;

export const TagBlock: FC<Props> = ({ tags, ...inherited }) => {
    return (
        <TagList data-section="Tag Link Block" {...inherited}>
            {tags.map((tag, index) => (
                <li key={index}>
                    <CapsuleShapedLink href={tag.href} data-element="Link" data-element-name={tag.name}>
                        {tag.name}
                    </CapsuleShapedLink>
                </li>
            ))}
        </TagList>
    );
};
